import ApiModel               from '@widesk-core/models/ApiModel';
import React                  from 'react';
import { Action }             from '@widesk-ui/components/ButtonActions';
import { EditOutlined }       from '@ant-design/icons';
import { Modal }              from '@widesk-ui/components/modal/Modal';
import { ModalProps }         from '@widesk-ui/components/modal/Modal';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';

type EditManyOptions<M extends typeof ApiModel> = {
	pluralModelName?: string;
	hideModelName?: boolean;
	modalProps?: Partial<ModalProps> | ((model: InstanceType<M>) => Partial<ModalProps>),
	actionProps?: Partial<Action>;
};

const actionEditManyModel = <MC extends typeof ApiModel & WithLocalizedLabel>(
	modelClass: MC,
	form: React.ReactNode,
	options?: EditManyOptions<MC>,
): Action => {
	const label = `Modifier les ${(options?.pluralModelName || modelClass.localize('plural')).toLowerCase()}`;

	return {
		label,
		icon: <EditOutlined />,
		onClick: () => Modal.open({ title: label, children: form, okText: 'Enregistrer', ...options?.modalProps }),
		...options?.actionProps,
	};
};

export default actionEditManyModel;
